var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-view-form" },
    [
      _c(
        "a-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.handleSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.viewName"), required: true } },
            [
              _c("a-input", {
                attrs: { placeholder: _vm.$t("tables.enterViewName") },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("message.description") } },
            [
              _c("a-input", {
                attrs: { placeholder: _vm.$t("tables.enterDesc") },
                model: {
                  value: _vm.description,
                  callback: function ($$v) {
                    _vm.description = $$v
                  },
                  expression: "description",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "a-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                { attrs: { type: "primary", htmlType: "submit" } },
                [_vm._v(_vm._s(_vm.$t("message.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }